import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getUserCollectionPortfolio } from '../../../../../../../lib/api';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
import {
  showAlert,
  validatePermissions,
} from '../../../../../../../lib/functions/utils';
import TransferList from './Components/TransferList';

interface PortfolioTransferProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  users: any[];
  selectedUser?: any; // Made optional for unified flow
}

const CollectionPortfolioTransfer: React.FC<PortfolioTransferProps> = (
  props,
) => {
  const { open, setOpen, selectedUser, users } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(0);
  const [userPortfolio, setUserPortfolio] = useState<any[]>([]);
  const [currentSelectedUser, setCurrentSelectedUser] = useState<any>(selectedUser);
  
  // Filter users based on permissions - only show users with collection portfolio permission
  const validUsers = users.filter(
    (user) =>
      validatePermissions(user, 'have_collection_portfolio') &&
      (!currentSelectedUser || user.id !== currentSelectedUser.id),
  );

  const fetchUserPortfolio = async (userId: number) => {
    setLoading(true);
    try {
      const response = await getUserCollectionPortfolio(
        dispatch,
        userId,
      );
      if (response.length === 0) {
        showAlert(dispatch, 'error', 'El usuario no tiene ruts en su cartera');
        return setOpen(false);
      }
      if (response) {
        setUserPortfolio(response);
      }
      showAlert(
        dispatch,
        'warning',
        'La cartera se transferirá de forma permanente',
      );
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener la cartera');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentSelectedUser) {
      fetchUserPortfolio(currentSelectedUser.id);
    }
  }, [currentSelectedUser]);

  // Update currentSelectedUser when selectedUser prop changes
  useEffect(() => {
    setCurrentSelectedUser(selectedUser);
  }, [selectedUser]);

  if (loading) {
    return <CenteredCircularProgress />;
  }

  // If no user is selected yet, show a user selection dialog
  if (!currentSelectedUser) {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
      >
        <DialogTitle>
          <Typography variant="h6">Seleccionar usuario origen</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Selecciona el usuario del cual quieres transferir la cartera de cobranza:
          </Typography>
          {validUsers.map((user) => (
            <div
              key={user.id}
              style={{
                padding: '12px',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                marginBottom: '8px',
                cursor: 'pointer',
                backgroundColor: '#fafafa'
              }}
              onClick={() => setCurrentSelectedUser(user)}
            >
              <Typography variant="subtitle1">{user.name}</Typography>
              <Typography variant="body2" color="text.secondary">
                {user.email}
              </Typography>
            </div>
          ))}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        maxWidth="xl"
      >
        <DialogTitle>
          <Typography variant="h6">Transferir cartera cobranza</Typography>
        </DialogTitle>
        <DialogContent>
          <TransferList
            setOpen={setOpen}
            reload={reload}
            setReload={setReload}
            selectedUser={currentSelectedUser}
            userPortfolio={userPortfolio}
            validUsers={validUsers}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CollectionPortfolioTransfer;
